export default {
      id: "ic-nav-swiper-next-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-nav-swiper-next-usage",
      toString: function () {
        return this.url;
      }
    }